import React from 'react';

interface Status {
  label: string;
  value: string | number;
  bgColor: string;
  textColor: string;
}

interface EscalationStatusProps {
  data: Status[];
  title: string;
}

const EscalationStatus: React.FC<EscalationStatusProps> = ({ data, title }) => {
  return (
    <div className="flex flex-row items-center gap-4 mt-3 mb-7">
      <h1 className="font-medium text-2xl">{title}</h1>
      <div className="flex gap-6">
        {data.map((status, index) => (
          <div key={index} className="flex flex-row items-center gap-2">
            <p>{status.label}</p>
            <div className={`${status.bgColor} rounded-full py-1 px-3`}>
              <p className={`text-xs font-semibold ${status.textColor}`}>
                {status.value}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default EscalationStatus;
